import AddonTypeCard from "./AddonTypeCard";
import {CgWebsite} from "react-icons/cg";
import {PiUserSquareFill} from "react-icons/pi";
import {useContext, useEffect, useState} from "react";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import DiscountCard, {ActiveDiscountCard} from "./DiscountCard";
import discount from "../../tools/api/companyApproval/discount";
import deleteDiscount from "../../tools/api/companyApproval/deleteDiscount";
import LoadingScreen from "../LoadingScreen";
import {CompanyApprovalContext} from "../../tools/contexts/companyApproval/CompanyApprovalContext";

const defaults = [

    {
        icon: <CgWebsite className="text-gray-500 text-5xl "/>,
        title: 'افزودن روی این آگهی',
        description: 'با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار خواهد گرفت.',
        type: 'postAddon',

    },
    {
        icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
        title: 'افزودن روی حساب کاربری',
        description: <span className="text-gray-700 text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما به مدت سه ماه اضافه
            خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</span>,
        type: 'userAddon',

    }
];
const ChooseAddonType = ({onConfirm, addonType = "postAddon"}) => {
    const [discountPreLoading, setDiscountPreLoading] = useState(true);
    const [discountLoading, setDiscountLoading] = useState(false);
    const [discountError, setDiscountError] = useState(null);
    const [deleteDiscountLoading, setDeleteDiscountLoading] = useState(false);
    const [deleteDiscountError, setDeleteDiscountError] = useState(null);
    const companyApprovalContext = useContext(CompanyApprovalContext);
    const [type, setType] = useState(addonType);
    useEffect(async () => {
        if (localStorage.getItem('discount_code') && companyApprovalContext.pid) {
            const params = {
                pid: companyApprovalContext.pid,
                code: localStorage.getItem('discount_code'),
            }
            const response = await discount(companyApprovalContext.token, params);
            const {hasError} = response;
            setDiscountPreLoading(false);
            localStorage.removeItem('discount_code')
            if (!hasError) {
                companyApprovalContext.handleGetProcess(companyApprovalContext.pid);
            }
        } else {
            setDiscountPreLoading(false)
        }
    }, []);
    const onSelect = (type) => {
        setType(type)
    }
    const handleConfirm = () => {
        onConfirm(type)
    }
    const handleDiscount = async (discountCode, showError = true) => {

        try {
            setDiscountLoading(true)
            const data = {
                "pid": companyApprovalContext.pid,
                "code": discountCode
            }
            const response = await discount(companyApprovalContext.token, data);
            setDiscountLoading(false)
            const {hasError, message} = response;
            if (hasError && showError) {
                setDiscountError(message)
            } else {
                await companyApprovalContext?.handleGetProcess(companyApprovalContext.pid)
            }
        } catch {
            setDiscountError('خطا سرویس. لطفا مجددا تلاش کنید.')
        }

    }

    const handleDeleteDiscount = async () => {
        try {
            setDeleteDiscountLoading(true)
            const params = {
                "pid": companyApprovalContext.pid,

            }
            const response = await deleteDiscount(companyApprovalContext.token, params);
            setDeleteDiscountLoading(false)
            const {hasError, message} = response;
            if (hasError) {

                setDeleteDiscountError(message)
            } else {
                setDiscountError(null)
                setDeleteDiscountError(null)
                await companyApprovalContext?.handleGetProcess(companyApprovalContext.pid)
            }
        } catch {
            setDiscountError('خطا سرویس. لطفا مجددا تلاش کنید.')
        }
    }
    if (discountPreLoading) {
        return <LoadingScreen/>
    }
    return <div className="w-full bg-gray-100 pt-5 min-h-screen">
        <div className="flex flex-col items-center justify-center">
            <h1 className="text-center font-bold   text-xl">
                احراز هویت حقوقی ونیفای
            </h1>
            <p className="text-sm mb-4 mt-1 ">لطفا نوع افزونه خود را انتخاب کنید.</p>
        </div>
        <div className="grid grid-cols-1 gap-6">
            {defaults.map((item, index) => (
                <AddonTypeCard isSelected={type === item.type} key={item.type + companyApprovalContext.process.discount}
                               data={item} onSelect={onSelect}/>
            ))}
        </div>
        <div className="w-full mt-4">
            {!companyApprovalContext.process.discount &&
                <DiscountCard loading={discountLoading} errorMessage={discountError} onConfirm={handleDiscount}/>}
            {companyApprovalContext.process.discount &&
                <ActiveDiscountCard error={deleteDiscountError} loading={deleteDiscountLoading} canDelete={true}
                                    onDelete={handleDeleteDiscount}
                                    code={companyApprovalContext.process.discount?.code}/>}

        </div>
        <BottomButtonWrapper>

            <Button onClick={handleConfirm} rounded="rounded-lg" className="text-sm" theme="green">مرحله بعد</Button>
        </BottomButtonWrapper>
    </div>
}
export default ChooseAddonType